import Page from "webPage/Page";
import $ from "jquery";
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";
import {registerScene, sectionGetHeight} from "util/parallax";

Page.register('page-template-products-lockers', () => {

    $('body').on('click', '.js-toggle-accordion', function () {
        $(this).parent('.icon-accordion').toggleClass('icon-accordion--active');
        return false;
    });

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-breadcrumb',
    //     duration: sectionGetHeight('.js-parallax-breadcrumb'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-breadcrumb-circle', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-features',
    //     duration: sectionGetHeight('.js-parallax-features'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-features-circle', 1, {yPercent: -10}, {yPercent: 10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-content',
    //     duration: sectionGetHeight('.js-parallax-content'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-content-circle', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-customisability',
    //     duration: sectionGetHeight('.js-parallax-customisability'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-customisability-circle', 1, {yPercent: -20}, {yPercent: 0}),
    // ])));
});